(function () {
	'use strict';

	// --- Minicart dropdown ---
	const minicart = document.querySelector('[data-hst-minicart]');
	if (minicart) {
		const trigger = minicart.querySelector('.hst-cart-trigger');
		const panel   = minicart.querySelector('.hst-minicart-panel');

		const close = () => {
			panel.classList.add('hidden');
			trigger.setAttribute('aria-expanded', 'false');
		};
		const open = () => {
			panel.classList.remove('hidden');
			trigger.setAttribute('aria-expanded', 'true');
		};

		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			panel.classList.contains('hidden') ? open() : close();
		});

		document.addEventListener('click', (e) => {
			if (!minicart.contains(e.target)) close();
		});
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') close();
		});
	}

	// --- Offcanvas ---
	const openOffcanvas = (id) => {
		const panel    = document.getElementById(id);
		const backdrop = document.querySelector('[data-hst-offcanvas-backdrop]');
		if (!panel) return;
		panel.classList.remove('translate-x-full');
		panel.setAttribute('aria-hidden', 'false');
		if (backdrop) {
			backdrop.classList.remove('opacity-0', 'pointer-events-none');
			backdrop.classList.add('opacity-100');
		}
		document.body.classList.add('hst-offcanvas-open');
	};
	const closeOffcanvas = (id) => {
		const panel    = document.getElementById(id);
		const backdrop = document.querySelector('[data-hst-offcanvas-backdrop]');
		if (!panel) return;
		panel.classList.add('translate-x-full');
		panel.setAttribute('aria-hidden', 'true');
		if (backdrop) {
			backdrop.classList.add('opacity-0', 'pointer-events-none');
			backdrop.classList.remove('opacity-100');
		}
		document.body.style.overflow = '';
	};

	document.addEventListener('click', (e) => {
		const opener = e.target.closest('[data-hst-offcanvas-open]');
		if (opener) {
			e.preventDefault();
			openOffcanvas(opener.dataset.hstOffcanvasOpen);
			return;
		}
		const closer = e.target.closest('[data-hst-offcanvas-close]');
		if (closer) {
			e.preventDefault();
			closeOffcanvas(closer.dataset.hstOffcanvasClose);
			return;
		}
		if (e.target.matches('[data-hst-offcanvas-backdrop]')) {
			document.querySelectorAll('.hst-offcanvas[aria-hidden="false"]')
				.forEach((p) => closeOffcanvas(p.id));
		}
	});

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			document.querySelectorAll('.hst-offcanvas[aria-hidden="false"]')
				.forEach((p) => closeOffcanvas(p.id));
		}
	});
})();